var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8815_45354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00081 15H3.33415C2.89212 15 2.4682 14.8244 2.15564 14.5118C1.84308 14.1993 1.66748 13.7754 1.66748 13.3333V9.16667C1.66748 8.72464 1.84308 8.30072 2.15564 7.98816C2.4682 7.6756 2.89212 7.5 3.33415 7.5H16.6675C17.1095 7.5 17.5334 7.6756 17.846 7.98816C18.1586 8.30072 18.3341 8.72464 18.3341 9.16667V13.3333C18.3341 13.7754 18.1586 14.1993 17.846 14.5118C17.5334 14.8244 17.1095 15 16.6675 15H15.0008",
    stroke: "#172A47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7.50081V2.50081C5 2.2798 5.0878 2.06784 5.24408 1.91156C5.40036 1.75528 5.61232 1.66748 5.83333 1.66748H14.1667C14.3877 1.66748 14.5996 1.75528 14.7559 1.91156C14.9122 2.06784 15 2.2798 15 2.50081V7.50081",
    stroke: "#172A47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 11.6675H5.83333C5.3731 11.6675 5 12.0406 5 12.5008V17.5008C5 17.9611 5.3731 18.3341 5.83333 18.3341H14.1667C14.6269 18.3341 15 17.9611 15 17.5008V12.5008C15 12.0406 14.6269 11.6675 14.1667 11.6675Z",
    stroke: "#172A47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8815_45354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintBlack);
export default __webpack_public_path__ + "static/media/print_black.720046de24652a7e38f7a1622e61f8a0.svg";
export { ForwardRef as ReactComponent };